export default __webpack_public_path__ + "static/media/illustration-study-3-w@3x.149cfb34.webp";